'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ActivityTypeService = function ActivityTypeService($http, $rootScope) {

    var activityTypeArray = [];

    /**
     * Get a list of activity types for select lists
     */

    var data = function data() {
        if (activityTypeArray.length === 0) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            activityTypeArray = $http.get(WEBSERVICEURL + '/dataagility/api/service.activity/selectlist').then(function (response) {
                return response.data;
            });
        }

        return activityTypeArray;
    };

    return { data: data };
};

exports.default = ActivityTypeService;


// WEBPACK FOOTER //
// ./client/app/common/services/activityType.service.js